import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from '../../utils/translate';
import { actions } from '../../actions/app';
import Modal from '../../components/Modal';
import { selector } from './selectors';

import './index.scss';

interface Props {}

const dispatchProps = {
  finish: actions.hidePasswordResetSuccessModal,
};

type Enhanced = Props & InjectedTranslateProps & ReturnType<typeof selector> & typeof dispatchProps;

const b = b_.with('password-reset-success-modal');

const enhance = compose<Enhanced, Props>(translate, connect(selector, dispatchProps));

class PasswordResetForm extends React.Component<Enhanced> {
  render() {
    const { t, email, finish } = this.props;

    return (
      <Modal onClose={finish} data-testid="password-reset-success-modal">
        <section className={b('section')}>
          <h2>{t('We sent a link to reset your password')}</h2>
          <p className="text-secondary">
            {t('We sent a link to reset your password {{email}}', { email })}
          </p>
          <button className={b('btn')} onClick={finish}>
            {t('Done')}
          </button>
        </section>
      </Modal>
    );
  }
}

export default enhance(PasswordResetForm);
